import { Box } from "@mui/material";
import { FC } from "react";

import { useAlarmColor } from "../hooks/use-alarm-color";

import { AlarmColorCategory, mapAlarmStatusToCategory } from "./alarm-colors";

export const ALARMS: Record<number, string> = {
  0: "Не определен",
  30: "Норма",
  40: "Недостоверность",
  45: "Внимание",
  50: "Обрыв датчика",
  60: "Предупреждение",
  90: "Авария",
  255: "Нет данных",
};

export {
  getDefaultAlarmColor,
  isNeutralAlarmStatusCategory,
  mapAlarmStatusToCategory,
  resolveAlarmColorFromPalette,
} from "./alarm-colors";
export type { AlarmColorCategory } from "./alarm-colors";

const DEVELOPMENT_RATE_LETTER: Partial<Record<AlarmColorCategory, string>> = {
  normal: "Н",
  alarm: "А",
  warning: "П",
  attention: "В",
};

export const SemaforIcon: FC<{
  status: number;
  width?: number;
  height?: number;
  labeled?: boolean;
}> = ({ status, width, height, labeled }) => {
  const color = useAlarmColor(status);
  const w = width ?? 12;
  const h = height ?? 12;
  const letter = labeled ? DEVELOPMENT_RATE_LETTER[mapAlarmStatusToCategory(status)] : undefined;

  return (
    <Box
      sx={{
        width: w,
        height: h,
        borderRadius: "50%",
        backgroundColor: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontSize: Math.min(w, h) * 0.52,
        fontWeight: 700,
        color: "#000000",
        lineHeight: 1,
        userSelect: "none",
      }}
    >
      {letter}
    </Box>
  );
};
